// @file Vuex store for locale selector
import { fetchJson, HTTPMethod } from '@padlet/fetch'
import getCsrfToken from 'bits/csrf_token'
import { hyphenatedCurrentLocale } from 'bits/current_locale'
import { availableLocales } from 'bits/locale'
import { Module } from 'vuex'

interface LocaleState {
  currentLocale: string
  isSelectorOpen: boolean
}

const initialState = (): LocaleState => {
  return {
    currentLocale: hyphenatedCurrentLocale,
    isSelectorOpen: false,
  }
}

const localeModule: Module<LocaleState, object> = {
  namespaced: true,
  state: initialState(),
  getters: {
    currentLocaleName: (state): string => {
      const currentLocaleObj = availableLocales.find((locale) => locale.html === state.currentLocale)
      return currentLocaleObj?.name || 'English (US)'
    },
    isDansk: (state): boolean => {
      return state.currentLocale === 'da'
    },
  },
  mutations: {
    SET_CURRENT_LOCALE(state, lang: string): void {
      state.currentLocale = lang
    },
    OPEN_LOCALE_MENU(state): void {
      state.isSelectorOpen = true
    },
    CLOSE_LOCALE_MENU(state): void {
      state.isSelectorOpen = false
    },
  },
  actions: {
    setCurrentLocale({ commit }, lang: string): void {
      commit('SET_CURRENT_LOCALE', lang)
    },
    openLocaleMenu({ commit }): void {
      commit('OPEN_LOCALE_MENU')
    },
    closeLocaleMenu({ commit }): void {
      commit('CLOSE_LOCALE_MENU')
    },
    async changeLocale({ commit }, lang: string): Promise<void> {
      commit('SET_CURRENT_LOCALE', lang)

      // Set locale in session
      await fetchJson('/session', {
        method: HTTPMethod.put,
        body: JSON.stringify({ lang }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken(),
        },
      })
    },
  },
}

export { LocaleState }
export default localeModule
